import HeadComponent from "@/components/HeadComponent";
import HeroSectionComponent from "@/components/HeroSectionComponent";
import PostCard from "@/components/Journal/PostCard";
import Avatar from "react-avatar";
import { callBackendApi } from "@/utils/common";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import ErrorStateImage from "@/images/stack empty state.svg";

const Journals = ({
  err,
  journalsData,
  topContributorsData,
  journalTagsData,
  tagData,
}) => {
  const latestJournals = journalsData;
  const topContributors = topContributorsData;
  const journalTags = journalTagsData;

  if (err.status === true) {
    return (
      <>
        <HeadComponent title={"Journal"} description={""} />
        <div className="m-auto d-flex justify-content-center align-items-center flex-column">
          <Image
            src={ErrorStateImage}
            width={700}
            height={300}
            className="mt-0"
          />
          <p className="text-muted mds-fs-md">
            {err.errMessage === "Tag Not Found"
              ? "Page Not Found"
              : "Something Went Wrong"}
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <HeadComponent title={tagData?.tagName} description={""} />
      <div className="mds-bg-primary-muted">
        <div className="container d-none d-lg-block">
          <nav className="py-3">
            <ol className="breadcrumb mds-breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/journal">
                  <a>Journal</a>
                </Link>
              </li>

              <li className="breadcrumb-item active">Tag</li>
              <li className="breadcrumb-item active">{tagData.tagName}</li>
            </ol>
          </nav>
        </div>
      </div>
      <HeroSectionComponent title={tagData.tagName} description="" />

      <div className="container py-5">
        <div className="row gy-3 gx-5">
          <div className="col-lg-8">
            <div>
              <div className="row row-cols-1 row-cols-lg-2 g-4">
                {latestJournals.length > 0
                  ? latestJournals.map((item) => (
                      <div key={item.slug} className="col">
                        <PostCard postData={item} />
                      </div>
                    ))
                  : null}
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="mb-5">
              <h2 className="m-0 pb-4 mds-fw-lg fs-4 mds-text-dark">Tags</h2>
              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-start">
                {console.log("journalTags", journalTags)}
                {journalTags.length > 0
                  ? journalTags.map((item) => (
                      <Link href={`/journal/tag/${item.slug}`} key={item.slug}>
                        <a>
                          <span
                            className={
                              "badge   mds-fw-sm px-3 py-2 fs-6 mds-rounded " +
                              (tagData.slug === item.slug
                                ? " mds-bg-primary text-white "
                                : " mds-bg-primary-light mds-text-dark ")
                            }
                          >
                            {item.tagName}
                          </span>
                        </a>
                      </Link>
                    ))
                  : null}
              </div>
            </div>

            <div className="mb-5">
              <h2 className="m-0 py-4 mds-fw-lg fs-4 mds-text-dark">
                Top contributor
              </h2>
              <div className="list-group list-group-flush ">
                {topContributors.map((item, index) => {
                  const { user } = item;
                  return (
                    <Link href={`/u/${user.username}`}>
                      <a
                        key={index}
                        className="list-group-item bg-transparent mds-text-dark ps-0"
                      >
                        {console.log(user)}
                        <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
                          <span className="d-flex align-items-center">
                            {user.imageUrl ? (
                              <Image
                                layout="fixed"
                                className="border mds-border-primary-light rounded-circle"
                                src={user.imageUrl}
                                width={30}
                                height={30}
                              />
                            ) : (
                              <Avatar name={user.fullName} size={30} round />
                            )}
                          </span>
                          <span className="text-capitalize mds-text-dark">
                            {user.fullName}
                          </span>
                          <span className="ms-auto text-muted text-nowrap">
                            {item.journalsCount}{" "}
                            {item.journalsCount > 1 ? "Journals" : "Journal"}
                          </span>
                        </div>
                      </a>
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const PrimaryComponent = () => {
  return (
    <div className="py-3">
      <button className="btn mds-btn-primary">Contact us</button>
    </div>
  );
};

export const getServerSideProps = async (context) => {
  const { slug } = context.query;
  let tagData = null;
  let journalsData = null;
  let topContributorsData = null;
  let journalTagsData = null;
  let err = { status: false, errMessage: null };

  try {
    const journalTagRes = await callBackendApi({
      method: "get",
      url: `/journal/tag/${String(slug).toLowerCase()}`,
      context: context,
    });

    tagData = journalTagRes.data.data.currentTag;
    journalsData = journalTagRes.data.data.journals;
  } catch (error) {
    err.status = true;
    err.errMessage = error.message;
    if (error.response) {
      err.errMessage = error.response.data.error;
    }
  }

  try {
    const topContributorsRes = await callBackendApi({
      method: "get",
      url: "/journal/users/top-users",
    });
    topContributorsData = topContributorsRes.data.data;
  } catch (error) {
    err.status = true;
    err.errMessage = error.message;
  }

  try {
    const journalTagsRes = await callBackendApi({
      method: "get",
      url: "/journal/all-tags",
    });
    journalTagsData = journalTagsRes.data.data;
  } catch (error) {
    err.status = true;
    err.errMessage = error.message;
  }

  return {
    props: {
      err,
      journalsData,
      topContributorsData,
      journalTagsData,
      tagData,
    },
  };
};

export default Journals;
